<script>
import { DatePicker } from 'element-ui';
import IMask from 'imask';
import moment from "moment";
export default {
  name: "ElDatePicker",
  mixins: [DatePicker],
  mounted() {
    let momentFormat = this.$props.format.toUpperCase().replace(':MM', ':mm');
    let mask = IMask(this.$el.getElementsByTagName('input')[0], {
      mask: Date,
      pattern: momentFormat,
      lazy: false,
      overwrite: true,
      autofix: true,
      min: new Date(1900, 0, 1),
      max: new Date(9999, 12, 31),

      format: function (date) {
        return moment(date).format(momentFormat);
      },
      parse: function (str) {
        return moment(str, momentFormat);
      },

      blocks: {
        YYYY: {
          mask: IMask.MaskedRange,
          from: 1900,
          to: 9999,
          maxLength: 4,
        },
        MM: {
          mask: IMask.MaskedRange,
          from: 1,
          to: 12,
          maxLength: 2,
        },
        DD: {
          mask: IMask.MaskedRange,
          from: 1,
          to: 31,
          maxLength: 2
        },
        HH: {
          mask: IMask.MaskedRange,
          from: 0,
          to: 23,
          maxLength: 2,
        },
        mm: {
          mask: IMask.MaskedRange,
          from: 0,
          to: 59,
          maxLength: 2,
        }
      }
    });

    mask.on("complete",  () => {
      this.$emit(
        'input',
        this.$data.userInput = mask.value
      )
    })
  }
}
</script>
